import { formatNumberRu } from '../lib/format-number.js';
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;
const SHORT = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', timeZone: 'UTC' });
const LONG = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
});
function isoDay(value) {
    if (typeof value !== 'string')
        return null;
    const m = ISO_DAY.exec(value);
    if (!m)
        return null;
    const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    return Number.isNaN(d.getTime()) ? null : d;
}
/**
 * Подпись оси X: день `YYYY-MM-DD` — «7 окт.», прочее — строкой как есть.
 * День — календарная дата ряда (движок уже свёл точки к дням), поэтому
 * форматируется в UTC, без сдвига в таймзону браузера.
 */
export function formatChartAxisLabelRu(value) {
    const d = isoDay(value);
    if (d)
        return SHORT.format(d);
    return value == null ? '' : String(value);
}
/** Заголовок тултипа: день — «7 октября 2026 г.», прочее — как на оси. */
export function formatChartTooltipLabelRu(value) {
    const d = isoDay(value);
    if (d)
        return LONG.format(d);
    return formatChartAxisLabelRu(value);
}
const COMPACT = new Intl.NumberFormat('ru-RU', { notation: 'compact', maximumFractionDigits: 1 });
/** Деления оси Y: «12 тыс.», «1,2 млн» — длинное число не съедает ширину графика. */
export function formatChartTickRu(value) {
    if (!Number.isFinite(value))
        return '';
    return Math.abs(value) >= 10_000 ? COMPACT.format(value) : formatNumberRu(value);
}
/** Значение в тултипе — полностью: «12 345», «2,4». */
export function formatChartValueRu(value) {
    if (!Number.isFinite(value))
        return '—';
    return formatNumberRu(value, { maximumFractionDigits: 2 });
}
//# sourceMappingURL=format.js.map